import React, { useState, useEffect } from 'react';
import { Translate } from '../../language';
import logoRecoverPassword from '../../img/logo_final_png.png';
import { connect } from 'react-redux'
import { sendCode, sendEmail } from '../../actions/regiterActions'
import ViewLogin from '../../containers/ViewLogin/ViewLogin';

const RegisterCodeVerification = ({ userEmail, sendCode, sendEmail, history, errorType, model, location }) => {
    var user = location?.state?.user
 //   var model = location.state.model
    ///console.log()
    const [code, setCode] = useState('')
    const [error, setError] = useState({})
    const [isValidate, setIsValidate] = useState(false)
    const [isEnabled, setIsEnabled] = useState(false)
    useEffect(()=>{
        if(!user){
            history.push('/RegisterUser')
        }
    },[user])

    useEffect(() => {
        console.log();
        var codeVar = 'code'
        if (errorType !== null && errorType.code === "ERR006") {
            setError(prevError => ({
                ...prevError,
                [codeVar]: Translate('ERR006', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR011") {
            setError(prevError => ({
                ...prevError,
                [codeVar]: Translate('ERR0011', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR012") {
            setError(prevError => ({
                ...prevError,
                [codeVar]: Translate('ERR0012', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR015") {
            setError(prevError => ({
                ...prevError,
                [codeVar]: Translate('ERR015', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR016") {
            setError(prevError => ({
                ...prevError,
                [codeVar]: Translate('ERR016', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "MSJ007") {
            console.log();
            setError(prevError => ({
                ...prevError,
                [codeVar]: Translate('ERR017', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR018") {
            setError(prevError => ({
                ...prevError,
                [codeVar]: Translate('ERR018', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR053") {
            setError(prevError => ({
                ...prevError,
                [codeVar]: Translate('ERR053', 'es')
            }));
        }
    }, [errorType])

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }

    const isEmpty = (e) => {

        const { name, placeholder, value } = e.target;
        setCode(value)
        if (value.length === 0) {
            setIsValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        else {
            setIsValidate(true)
            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }
    }


    const goToLoginCode = (e) => {
        e.preventDefault()
        setIsEnabled(false)
        sendEmail(code,history)
    }

    return (
        <div>
            <ViewLogin
                type='text'
                nameInput='code'
                img={logoRecoverPassword}
                inputValue={code}
                error={error.code}
                onChangeInput={isEmpty}
                onFocusInput={isFocused}
                inputPlaceholder="verificationCode"
                textButton="send"
                isEnabled={isEnabled}
                setIsEnabled={setIsEnabled}
                actionButton={goToLoginCode}
                textDown=''
                TextlinkDown=''
                linkToDown=''
                isMenuDown={true}
                isBackgroundBlue={false}
                isActiveButton={isValidate}
                isResendCodeVerification={true}
                actionResendCode={() => {
                    setIsEnabled(false)
                    sendCode( user, history)
                }}
            />
        </div>
    )
}

const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        userEmail: state.register.email,
        errorType: state.register.errorType,
        model: state.register.model
    }
}

export default connect(mapStateToProps, { sendCode, sendEmail })(RegisterCodeVerification)
